import {UserModel} from '../../../../app/modules/auth';

export const generateUserAvatarImage = (currentUser: UserModel | undefined) => {
  if (!currentUser) return `https://avatars.dicebear.com/api/adventurer-neutral/default-avatar.svg`;
  return `https://api.dicebear.com/5.x/initials/svg?seed=${currentUser?.first_name} ${currentUser?.last_name}`;
};
